import * as React from "react"
import { Head as HeadComponent, Layout } from "@bw/layouts"
import { PageHeader } from "@bw/modules"
import { Button, Section } from "@bw/bits"
import { useTranslation } from "react-i18next"

export const Head = ({ location, pageContext }) => (
  <HeadComponent title="404" location={location} pageContext={pageContext} />
)

const NotFoundPage = ({ pageContext }) => {
  const { t } = useTranslation()
  return (
    <Layout {...{ pageContext }}>
      <PageHeader title={t("404.title")} />
      <Section>
        <Button to="/" label={t("404.button")} />
      </Section>
    </Layout>
  )
}

export default NotFoundPage
